import React from "react";

import HeroBanner from "../../components/HeroBanner/HeroBanner";
import ContactForm from "../../components/Forms/ContactForm";

const ContactUs = () => {
  const title = "Contact Us";
  const description =
    `Have questions, need assistance, or want to partner with us? Bricksnmix is here to help!
Whether you’re placing an order, exploring seller opportunities, or looking for expert product guidance, our team is just a message or call away.


`;
const subtitle2 = `📞 Call Us: 8594005250
`
const subtitle3 = `📧 Email Us: bricksnmix@gmail.com
`
const subtitle4 = "Fill out the contact form below, and we’ll get back to you promptly to ensure your experience is smooth and hassle-free.";
  return (
    <div>
      <HeroBanner title={title} subtitle={description} subtitle2={subtitle2} subtitle3={subtitle3} subtitle4={subtitle4} />
      <div className=" py-20 px-2 sm:px-20 ">
        <ContactForm/>
      </div>
    </div>
  );
};

export default ContactUs;
